import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Formik } from 'formik';
import store from 'store';

import SelectField from '@common/components/Form/SelectField';
import { IGroupModel } from '@common/models/Groups/Group';

import { StyledAppointmentsSelectPartForm, StyledAppointmentsSelectPartWrap } from './styled';

function AppointmentsSelectPart({ filters, teachers, onSubmit, programs }: any) {
	const { t } = useTranslation();

	return (
		<StyledAppointmentsSelectPartWrap>
			<Formik
				initialValues={{
					...filters,
					teacher_id: null,
				}}
				onSubmit={onSubmit}
			>
				{({ values, submitForm }) => (
					<StyledAppointmentsSelectPartForm>
						<SelectField
							label={t('appointment.location')}
							name="location_id"
							options={store.profile.serviceLocations.map((location) => ({
								label: location.name,
								value: location.id,
							}))}
							onChange={submitForm}
							sx={{ background: '#fff', boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)' }}
						/>
						<SelectField
							label={t('appointment.group')}
							name="group_id"
							options={store.student.groups
								.filter((group: IGroupModel) => group.location.id === values.location_id)
								.map((location: IGroupModel) => ({
									label: location.name,
									value: location.id,
								}))}
							onChange={submitForm}
							sx={{ background: '#fff', boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)' }}
						/>
						<SelectField
							label={t('appointment.program')}
							name="program_id"
							options={programs}
							onChange={submitForm}
							sx={{ background: '#fff', boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)' }}
						/>
						<SelectField
							label={t('appointment.teacher')}
							name="teacher_id"
							options={teachers.map((teacher: any) => ({
								label: [
									`${teacher.first_name} ${teacher.last_name}`,
									...(teacher.job_title ? [`(${teacher.job_title})`] : []),
								].join(' '),
								value: teacher.id,
							}))}
							onChange={submitForm}
							sx={{ background: '#fff', boxShadow: '0px 0px 30px 0px rgba(130, 125, 131, 0.15)' }}
						/>
					</StyledAppointmentsSelectPartForm>
				)}
			</Formik>
		</StyledAppointmentsSelectPartWrap>
	);
}

export default observer(AppointmentsSelectPart);
